import * as Raven from '@sentry/browser';

export default Raven;
